module.exports = __webpack_public_path__ + "static/img/add-white.6ae89ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/add-white.png
// module id = 1TSq
// module chunks = 1